module.exports = __webpack_public_path__ + "static/media/Web_Label_Apple.f2893f2f.png";